import Api from '@/api'
import CustomTrade from '@/models/CustomTrade'

export default {
  namespaced: true,

  state: {
    trades: [],
    tradesMeta: null,
    trade: null,
  },

  getters: {
    trades(state) {
      return state.trades
    },
    tradesMeta(state) {
      return state.tradesMeta
    },
    trade(state) {
      return state.trade
    },
  },

  mutations: {
    setTrades(state, trades) {
      state.trades = trades
    },
    setTradesMeta(state, tradesMeta) {
      state.tradesMeta = tradesMeta
    },
    clearTrades(state) {
      state.trades = []
    },

    setTrade(state, trade) {
      state.trade = trade
    },
    clearTrade(state) {
      state.trade = { name: '' }
    },
  },

  actions: {
    async getTrades({ commit }, params) {
      const query = CustomTrade.params({
        paginate: params.paginate !== null ? params.paginate : 1,
      })
        .page(params.page || 1)
        .limit(params.limit || 10)

      query.where('search', params.search || null)

      const res = await query.get()
      commit('setTrades', res.data)
      commit('setTradesMeta', res.meta)
    },

    async getTrade({ commit }, params) {
      commit('clearTrade')

      await new Promise(async (resolve, reject) => {
        await Api.get(`/custom-trades/${params.id}`, { params: params })
          .then((res) => {
            commit('setTrade', res.data.data)
            resolve(res.data.data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async createTrade({ commit }, customTrade) {
      await new Promise(async (resolve, reject) => {
        await Api.post('/custom-trades', customTrade)
          .then((res) => {
            commit('setTrade', res.data.data)
            resolve(res.data.data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async updateTrade({ commit }, customTrade) {
      await new Promise(async (resolve, reject) => {
        await Api.patch('/custom-trades', customTrade)
          .then((res) => {
            // commit('setTrade', res.data.data)
            resolve(res.data.data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async deleteTrade({ commit }, id) {
      await new Promise(async (resolve, reject) => {
        await Api.delete(`/custom-trades/${id}`)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => reject(err.response))
      })
    },

    async getPickerValues({ commit }) {
      await new Promise(async (resolve, reject) => {
        await Api.get('/trades/picker-values')
          .then((res) => {
            commit('setTrades', res.data.data)
            resolve(res.data.data)
          })
          .catch((err) => reject(err.response))
      })
    },
  },
}
